// Components==============
import {
    faArrowRight,
    faCheck,
    faTimes,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React from 'react';
import './StatusBox.module.scss';
// =========================

export type BoxTypes = 'initial' | 'correct' | 'wrong' | 'submit' | 'failed';

type Props = {
    boxState: BoxTypes;
    background?: string;
    inputField?: boolean;
    disableGridPlacement?: boolean;
    fullSize?: boolean;
};

const inputRadius = '0px 4px 4px 0px';

export default function StatusBox({
    boxState,
    background = '#FFFFFF',
    inputField,
    disableGridPlacement,
    fullSize,
}: Props) {
    const buttonVariants = {
        initial: { background },
        failed: {
            background: '#ffffff',
        },
        correct: { background: '#16D872' },
        wrong: { background: '#F66B12' },
        submit: { background: '#181818' },
    };

    return (
        <motion.button
            styleName="wrapper"
            type="submit"
            variants={buttonVariants}
            animate={boxState}
            initial="initial"
            style={{
                cursor: boxState !== 'submit' ? 'default' : 'pointer',
                borderRadius:
                    boxState === 'correct'
                        ? '4px'
                        : inputField
                        ? inputRadius
                        : '4px',
                gridColumn: disableGridPlacement ? 'initial' : '',
                gridRow: disableGridPlacement ? 'initial' : '',
                width: fullSize ? '100%' : '',
                height: fullSize ? '100%' : '',
            }}
        >
            {boxState === 'correct' ? (
                <FontAwesomeIcon icon={faCheck} />
            ) : boxState === 'submit' ? (
                <FontAwesomeIcon icon={faArrowRight} />
            ) : boxState === 'wrong' ? (
                <FontAwesomeIcon icon={faTimes} />
            ) : null}
        </motion.button>
    );
}
